<template>
  <z-form class="z-card" tag="div">
    <h4>{{ $t('pbx.contact.form.title.edit.main') }}</h4>

    <div class="z-card__body">
      <z-form-group class="row align-items-center">
        <label class="col-2 text-right">
          {{ $t('pbx.contact.table.field.first_name') }}
        </label>

        <div class="col-10">
          <z-form-input :rules="{ required: true }" vid="first_name">
            <i-input v-model="form.first_name" :clearable="true" />
          </z-form-input>
        </div>
      </z-form-group>

      <z-form-group class="row align-items-center">
        <label class="col-2 text-right">
          {{ $t('pbx.contact.table.field.last_name') }}
        </label>

        <div class="col-10">
          <z-form-input :rules="{ required: true }" vid="last_name">
            <i-input v-model="form.last_name" :clearable="true" />
          </z-form-input>
        </div>
      </z-form-group>
    </div>
  </z-form>
</template>

<script>
  import isEqual from 'lodash-es/isEqual';

  export default {
    props: {
      value: {
        type: Object,
        default: () => {}
      }
    },

    data() {
      return {
        form: {}
      };
    },

    watch: {
      value: {
        handler: function(value) {
          const { first_name = '', last_name = '' } = value || {};
          this.form = { first_name, last_name };
        },
        immediate: true,
        deep: true
      },

      form: {
        handler: function(form) {
          if (!isEqual(form, this.value)) {
            this.$emit('input', form);
          }
        },
        immediate: true,
        deep: true
      }
    }
  };
</script>
